import ajaxProxy from '../globs/ajax-proxy';
import appLogout from './app-logout';

export default function dataLoad({ key, url }) {
  return (dispatch) => {
    dispatch(dataLoadPending(key));

    ajaxProxy
      .dataLoad({ key, url })
      .then((response) => {
        dispatch(dataLoadFulfilled(key, response));
      })
      .catch((errResponse) => {
        dispatch(dataLoadRejected(key));

        const shouldInvalidateSession = errResponse &&
          errResponse.response &&
          (errResponse.response.status === 403 || errResponse.response.status === 401);

        if (shouldInvalidateSession) {
          dispatch(appLogout());
          console.log('logout')
        }
      });
  };
}

function dataLoadPending(key) {
  return {
    type: 'data-load_PENDING',
    payload: { key },
  };
}

function dataLoadFulfilled(key, response) {
  return {
    type: 'data-load_FULFILLED',
    payload: { key, response },
  };
}

function dataLoadRejected(key) {
  return {
    type: 'data-load_REJECTED',
    payload: { key },
  };
}
